import React from 'react';
import { Loader2 } from 'lucide-react';

export const Loading = ({ on }) => (on ? (
  <div className="absolute inset-0 z-20 bg-white/60 backdrop-blur-[1px] flex items-start justify-center pt-24" data-testid="sa-loading-overlay">
    <div className="flex items-center gap-2 rounded-full bg-[#3b2416] text-white text-xs px-4 py-2 shadow-lg">
      <Loader2 size={14} className="animate-spin" /> Updating…
    </div>
  </div>
) : null);
